import { USE_JOTTER } from 'redux/modules/multi-search/actions/types';

export const useJotter = () => ({
  type: USE_JOTTER,
});
